'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBase = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactackleCore = require('reactackle-core');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _LabelWrapperStyled = require('./styles/LabelWrapperStyled');

var _SupplementTextStyled = require('./styles/SupplementTextStyled');

var _ValueLabelStyled = require('./styles/ValueLabelStyled');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  /**
   * Progress line will change its colour accordingly to progress
   */
  dynamicColor: _propTypes2.default.bool,

  /**
   * Specifies progress mode. Indeterminate one doesn't have value.
   */
  indeterminate: _propTypes2.default.bool,

  /**
   * Specifies max value to calculate progress from
   */
  max: _propTypes2.default.number,

  /**
   * Specifies min value to calculate progress from
   */
  min: _propTypes2.default.number,

  /**
   * Specifies current value to calculate progress from
   */
  value: _propTypes2.default.number,

  /**
   * Shows a progress label with the exact value (=shows this.props.value)
   * Has priority over progressLabel
   */
  exactProgressLabel: _propTypes2.default.bool,

  /**
   * Show postfix after exact progress label
   */
  labelPostfix: _propTypes2.default.string,

  /**
   * Shows a progress label with the percentage value
   */
  progressLabel: _propTypes2.default.bool,

  /**
   * Set text align for progress label
   */
  labelPositionX: _propTypes2.default.oneOf(['left', 'center', 'right']),

  /**
   * Set label position. "Center" is valid for circle progress only.
   */
  labelPositionY: _propTypes2.default.oneOf(['top', 'center', 'bottom']),

  /**
   * Set subtitle for progress label
   */
  subtitle: _propTypes2.default.string,

  /**
   * Add secondary progress line
   */
  withSecondaryProgress: _propTypes2.default.bool,
  // eslint-disable-line react/no-unused-prop-types

  /**
   * Value for secondary progress
   */
  secondaryProgressValue: _propTypes2.default.number,

  /**
   * Value for aria-valuetext attr
   */
  ariaValueText: _propTypes2.default.string,

  /**
   * Theme provided by withTheme HOC
   */
  theme: _propTypes2.default.object.isRequired
};
var defaultProps = {
  dynamicColor: false,
  indeterminate: false,
  max: 100,
  min: 0,
  value: 0,
  exactProgressLabel: false,
  labelPostfix: '',
  progressLabel: false,
  labelPositionX: 'left',
  labelPositionY: 'top',
  subtitle: '',
  withSecondaryProgress: false,
  secondaryProgressValue: 0,
  ariaValueText: ''
};

var normalizeValue = function normalizeValue(value, min, max) {
  return ((0, _reactackleCore.minMax)(value, min, max) - min) / (max - min);
};

var ProgressBase = exports.ProgressBase = function (_Component) {
  _inherits(ProgressBase, _Component);

  function ProgressBase() {
    _classCallCheck(this, ProgressBase);

    return _possibleConstructorReturn(this, (ProgressBase.__proto__ || Object.getPrototypeOf(ProgressBase)).apply(this, arguments));
  }

  _createClass(ProgressBase, [{
    key: '_getNormalizedProgress',
    value: function _getNormalizedProgress() {
      var _props = this.props,
          value = _props.value,
          min = _props.min,
          max = _props.max;
      return normalizeValue(value, min, max);
    }
  }, {
    key: '_getNormalizedSecondaryProgress',
    value: function _getNormalizedSecondaryProgress() {
      var _props2 = this.props,
          secondaryProgressValue = _props2.secondaryProgressValue,
          min = _props2.min,
          max = _props2.max;
      var value = normalizeValue(secondaryProgressValue, min, max);

      var progress = this._getNormalizedProgress();

      return value < progress ? progress : value;
    }
  }, {
    key: '_getProgressColor',
    value: function _getProgressColor(progressType) {
      var _props3 = this.props,
          dynamicColor = _props3.dynamicColor,
          theme = _props3.theme;
      var componentTheme = theme.reactackle.components.progress;
      var colors = componentTheme[progressType].mainLine;
      var startColor = colors.startColor,
          endColor = colors.endColor,
          color = colors.color;

      if (dynamicColor) {
        var start = (0, _color2.default)(startColor);
        var end = (0, _color2.default)(endColor);

        var progress = this._getNormalizedProgress();

        return start.mix(end, progress);
      } else {
        return (0, _color2.default)(color);
      }
    }
  }, {
    key: '_getSecondaryProgressColor',
    value: function _getSecondaryProgressColor(progressType) {
      var theme = this.props.theme;
      var componentTheme = theme.reactackle.components.progress;
      var _componentTheme$progr = componentTheme[progressType].secondaryLine,
          color = _componentTheme$progr.color,
          opacity = _componentTheme$progr.opacity;
      return color ? (0, _color2.default)(color) : this._getProgressColor(progressType).fade(1 - opacity);
    }
  }, {
    key: '_getAriaAttributes',
    value: function _getAriaAttributes() {
      var _props4 = this.props,
          indeterminate = _props4.indeterminate,
          min = _props4.min,
          max = _props4.max,
          value = _props4.value,
          subtitle = _props4.subtitle,
          ariaValueText = _props4.ariaValueText;
      var ret = {
        role: 'progressbar'
      };
      var valueText = ariaValueText || subtitle;
      if (valueText) ret['aria-valuetext'] = valueText;

      if (!indeterminate) {
        ret['aria-valuenow'] = String(value);
        ret['aria-valuemin'] = String(min);
        ret['aria-valuemax'] = String(max);
      }

      return ret;
    }
  }, {
    key: '_renderPrimaryText',
    value: function _renderPrimaryText(progressType) {
      var _props5 = this.props,
          progressLabel = _props5.progressLabel,
          exactProgressLabel = _props5.exactProgressLabel,
          value = _props5.value,
          labelPostfix = _props5.labelPostfix;
      var text = void 0;
      if (!progressLabel && !exactProgressLabel) return null;

      if (exactProgressLabel) {
        text = '' + value + labelPostfix;
      } else {
        var progressPercent = Math.round(this._getNormalizedProgress() * 100);
        text = progressPercent + '%';
      }

      return _react2.default.createElement(_ValueLabelStyled.ValueLabelStyled, {
        progressType: progressType
      }, text);
    }
  }, {
    key: '_renderSubtitle',
    value: function _renderSubtitle(progressType) {
      var _props6 = this.props,
          subtitle = _props6.subtitle,
          children = _props6.children;
      if (!children && !subtitle) return null;
      return _react2.default.createElement(_SupplementTextStyled.SupplementTextStyled, {
        progressType: progressType
      }, children && subtitle ? _react2.default.createElement('div', null, subtitle) : subtitle, children);
    }
  }, {
    key: '_renderLabel',
    value: function _renderLabel(progressType) {
      var _props7 = this.props,
          progressLabel = _props7.progressLabel,
          exactProgressLabel = _props7.exactProgressLabel,
          subtitle = _props7.subtitle,
          labelPositionX = _props7.labelPositionX,
          labelPositionY = _props7.labelPositionY;
      if (!progressLabel && !exactProgressLabel && !subtitle) return null;
      return _react2.default.createElement(_LabelWrapperStyled.LabelWrapperStyled, {
        labelAlign: labelPositionX,
        labelPositionY: labelPositionY,
        progressType: progressType
      }, this._renderPrimaryText(progressType), this._renderSubtitle(progressType));
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return ProgressBase;
}(_react.Component);

ProgressBase.propTypes = propTypes;
ProgressBase.defaultProps = defaultProps;
ProgressBase.displayName = 'ProgressBase';